import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  closeDetailP: false,
  isshow_detail: true, //默认显示商品详情页，不显示图文详情
  newRouteName: '', //判断导航
  oldRouteName: '',
  hotSearch: [{
    name: "气体报警器"
  }, {
    name: "温控器"
  }], //热门搜索记录
  historySearch: [{
    name: '猫眼'
  }], //历史搜索
  isRightToBuy: false, //默认加入购物车中
  selectGoods: [], //购物车选中的
  cartGoodstoPay: [], //购物车选中的提交支付的商品列表
  toBuy: [], //直接购买的
  allGood: [], //所有订单、待支付的、已支付的、已收货的
  detailChosenList: {}, //选中的购物车商品信息
  toBepay: [{
    check: true,
    color: "黑色",
    count: 1,
    desc: "待支付",
    goodsDetail: {
      name: '海曼烟雾',
      id: 'product_frozen',
      price: '329.99',
      imgsrc: "../../static/image/productFrozen/Photo.png",
      src: '../../static/image/productFrozen/Photo.png',
      currentPrice: '329.99',
      oldPrice: '529.99',
      thumb: [
        '../../static/image/productFrozen/Photo.png',
        '../../static/image/productFrozen/1.png',
      ],
      sku: {
        sku_color: ['肤色', '米色', '黑色'],
        sku_size: ['基础版', "标准版", "升级版"],
        sku_num: '234',
        sku_buy_count: '',
      },
      isMark: 1, //0收藏、1不收藏
      pictureDetail: [
        '../../static/image/productFrozen/1.png',
        '../../static/image/productFrozen/2.png',
        '../../static/image/productFrozen/3.png',
        '../../static/image/productFrozen/4.png',
        '../../static/image/productFrozen/5.png',
        '../../static/image/productFrozen/6.png',
      ],
      detail: {
        goodsNo: '13123',
        goodKind: '家用',
        goodFun: '监控',
        goodExt: '直充',
        goodsColorCover: '黑色',
        goodsUseCover: '0.1平方米',
        goodsProduct: '海曼烟雾'
      }
    },
    id: "product_frozen",
    kid: "product_frozen-黑色-升级版",
    name: "海曼烟雾",
    orderNo: 5985797,
    payMoney: "329.99",
    payTime: "2019-6-26  21:21",
    payway: "微信",
    personAddress: "广东省广州市荔湾区建设大道11号",
    personName: "王五",
    personPhone: "1320000000",
    price: "329.99",
    size: "升级版",
    sumbitTime: "2019-6-26  21:21",
    whichList: "1"
  }], //待支付的
  tosendgood: [{
    whichList: '3',
    check: true,
    color: "黑色",
    count: 3,
    desc: "待支付",
    goodsDetail: {
      name: '海曼独立式光电感烟火灾报警器',
      id: 'alarmDevice',
      price: '128.99',
      src: '../../static/image/alarmDevice/Photo.png',
      imgsrc: '../../static/image/alarmDevice/Photo.png',
      currentPrice: '128.99',
      oldPrice: '129.8',
      thumb: [
        '../../static/image/alarmDevice/Photo.png',
        '../../static/image/alarmDevice/1.png',
      ],
      sku: {
        sku_color: ['黑色', '白色'],
        sku_size: ['基础版', '标准版', "升级版"],
        sku_num: '222',
        sku_buy_count: '',
      },
      isMark: 0,
      pictureDetail: [
        '../../static/image/alarmDevice/1.png',
        '../../static/image/alarmDevice/2.png',
        '../../static/image/alarmDevice/3.png',
        '../../static/image/alarmDevice/4.png',
        '../../static/image/alarmDevice/5.png',
        '../../static/image/alarmDevice/6.png',
      ],
      detail: {
        goodsNo: '33795797995',
        goodKind: '家用气体检测报警器',
        goodFun: '防盗报警、气体检测',
        goodExt: '工作电压AC220V',
        goodsColorCover: '黑色、白色',
        goodsUseCover: '110*70*40mm',
        goodsProduct: '海曼智能家居'
      }
    },
    id: "alarmDevice",
    kid: "alarmDevice-黑色-标准版",
    name: "智能可燃气体报警器",
    price: "129.99",
    size: "标准版",
    orderNo: 3244243,
    payTime: "2019-6-26  20:20",
    payway: "支付宝",
    personAddress: "广东省广州市荔湾区建设大道11号",
    personName: "王五",
    personPhone: "1320000000",
    price: "229.99",
    sumbitTime: "2019-6-26  20:21",
    whichList: "3"
  }], //已支付的,待收货的
  toAssess: [], //待评价
  bookMark: [], //收藏夹数据
  // isShow_nav: true, //导航栏显示,
  //已选的商品，确定id、跳到对应的detail页
  product_id: '',
  commonGood: [], //用于购物修改地址后返回原来页面的
  lists: [{
      name: '海曼独立式光电感烟火灾报警器',
      id: 'product_frozen',
      // kid: 'product_frozen-白色-标准版',
      price: '128.9',
      imgsrc: '../../static/image/productFrozen/Photo.png',
      src: '../../static/image/productFrozen/Photo.png',
      currentPrice: '128.9',
      oldPrice: '139.8',
      thumb: [
        '../../static/image/productFrozen/img1.png',
        '../../static/image/productFrozen/1.png',
      ],
      sku: {
        sku_color: ['白色'],
        sku_size: ["标准版"],
        sku_num: '234',
        sku_buy_count: '',
        sku_pic: ['../../static/image/productFrozen/Photo.png']
      },
      isMark: 0, //0收藏、1不收藏
      pictureDetail: [
        '../../static/image/productFrozen/1.png',
        '../../static/image/productFrozen/2.png',
        '../../static/image/productFrozen/3.png',
        '../../static/image/productFrozen/4.png',
        '../../static/image/productFrozen/5.png',
        '../../static/image/productFrozen/6.png',
      ],
      detail: {
        goodsNo: '33795797995', //商品编号
        goodKind: 'HS1SA', //型号
        goodFun: '烟雾报警器', //功能
        goodExt: '电池供电', //电源方式
        goodsColorCover: '白色', //颜色
        goodsUseCover: '60*60*49mm', //使用面积
        goodsProduct: '海曼智能家居',
        goodpackaging: "烟雾报警器主机× 1、说明书× 1、售后服务书× 1",
        goodAfterSale: "七天无理由退换货，一年质保，如因质量问题或故障，凭厂商维修中心或特约维修点的质量检测证明，享受7日内退货，15以上在质保期间内享受免费保修登三包服务",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      }
    },
    {
      name: '海曼智能可燃气体报警器',
      id: 'alarmDevice',
      //  kid: 'alarmDevice-白色-标准版',
      price: '149.99',
      src: '../../static/image/alarmDevice/Photo.png',
      imgsrc: '../../static/image/alarmDevice/Photo.png',
      currentPrice: '149.99',
      oldPrice: '159.99',
      thumb: [
        '../../static/image/alarmDevice/img.png',
        '../../static/image/alarmDevice/1.png',

      ],
      sku: {
        sku_color: ['白色'],
        sku_size: ['标准版'],
        sku_num: '222',
        sku_buy_count: '',
        sku_pic: ['../../static/image/alarmDevice/Photo.png']
      },
      isMark: 0,
      pictureDetail: [
        '../../static/image/alarmDevice/1.png',
        '../../static/image/alarmDevice/2.png',
        '../../static/image/alarmDevice/3.png',
        '../../static/image/alarmDevice/4.png',
        '../../static/image/alarmDevice/5.png',
        '../../static/image/alarmDevice/6.png',
      ],
      detail: {
        goodsNo: '436452322',
        goodKind: 'HS1CG',
        goodFun: '可燃气体报警器',
        goodExt: '220V电压通电',
        goodsColorCover: '白色',
        goodsUseCover: '79*68*58mm',
        goodsProduct: '海曼智能家居',
        goodpackaging: "报警器主机*1、说明书*1、500万保险卡*1、售后服务书× 1",
        goodAfterSale: "本产品全国联保，享受三包服务，质保期为：1年质保",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      }
    },
    {
      name: 'Aqara温湿度传感器',
      id: 'thermostat',
      // kid: 'thermostat-白色-标准版',
      price: '69.99',
      src: '../../static/image/thermostat/Photo.png',
      imgsrc: '../../static/image/thermostat/Photo.png',
      currentPrice: '69.99',
      oldPrice: '89.99',
      thumb: [
        '../../static/image/thermostat/Photo.png',
        '../../static/image/thermostat/1.png',
      ],
      sku: {
        sku_color: ['白色'],
        sku_size: ['标准版'],
        sku_num: '112',
        sku_buy_count: '',
        sku_pic: ['../../static/image/thermostat/Photo.png']
      },
      isMark: 0,
      pictureDetail: [
        '../../static/image/thermostat/1.png',
        '../../static/image/thermostat/2.png',
        '../../static/image/thermostat/3.png',
        '../../static/image/thermostat/4.png',
        '../../static/image/thermostat/5.png',
      ],
      detail: {
        goodsNo: '4234230065',
        goodKind: 'WSDCGQ11LM',
        goodFun: '温湿度检测，气压检测',
        goodExt: '米家APP控制',
        goodsColorCover: '白色',
        goodsUseCover: '120*120*30mm',
        goodsProduct: 'Aqara智能家居',
        goodpackaging: "温湿度传感器×1、说明书及三包卡×1",
        goodAfterSale: "本产品全国联保，享受三包服务，质保期为：一年质保",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      }
    },
    {
      name: 'EZVIZ萤石 C2C监控摄像头',
      id: 'c2cCamera',
      // kid: 'c2cCamera-白色-标准版',
      price: '169.99',
      src: '../../static/image/c2cCamera/img1.png',
      imgsrc: '../../static/image/c2cCamera/img1.png',
      currentPrice: '169.99',
      oldPrice: '178.99',
      thumb: [
        '../../static/image/c2cCamera/img1.png',
        '../../static/image/c2cCamera/6.png',
      ],
      sku: {
        sku_color: ['白色'],
        sku_size: ['标准版'],
        sku_num: '100',
        sku_buy_count: '',
        sku_pic: ['../../static/image/c2cCamera/Photo.png']
      },
      isMark: 0,
      pictureDetail: [
        '../../static/image/c2cCamera/1.png',
        '../../static/image/c2cCamera/2.png',
        '../../static/image/c2cCamera/3.png',
        '../../static/image/c2cCamera/4.png',
        '../../static/image/c2cCamera/5.png',
        '../../static/image/c2cCamera/6.png',
      ],
      detail: {
        goodsNo: '31135642358',
        goodKind: 'CS-C2C-1A1WFR',
        goodFun: 'CMOS交互型互联网摄像机',
        goodExt: '手机APP\PC\WEB端都可控制',
        goodsColorCover: '白色',
        goodsUseCover: '110*58*38mm',
        goodsProduct: '萤石EZVIZ',
        goodpackaging: "C2C互联网摄像机 × 1、USB电源线 × 1、C2C快速操作指南 × 1、售后服务书× 1",
        goodAfterSale: "本产品全国联保，享受三包服务，质保期为：1年质保",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      }
    },
    {
      name: 'Vine温控器',
      id: 'VineThermostat',
      // kid: 'VineThermostat-白色-标准版',
      price: '229.99',
      src: '../../static/image/VineThermostat/white.png',
      imgsrc: '../../static/image/VineThermostat/white.png',
      currentPrice: '229.99',
      oldPrice: '259.99',
      thumb: [
        '../../static/image/VineThermostat/img.png',
        '../../static/image/VineThermostat/1.png'
      ],
      sku: {
        sku_color: ['白色', '黑色'],
        sku_size: ['标准版'],
        sku_num: '142',
        sku_buy_count: '',
        sku_pic: ['../../static/image/VineThermostat/white.png',
          '../../static/image/VineThermostatB/black.png'
        ]
      },
      isMark: 0,
      detail: {
        goodsNo: '4234230000',
        goodKind: 'CDK200',
        goodFun: 'Vine手机远程温控定时开关',
        goodExt: '220V', //操作方式
        goodsColorCover: '白色',
        goodsUseCover: '120*120*30MM',
        goodsProduct: '欧诺德',
        goodpackaging: "Vine温控器× 1、说明书× 1、售后服务书× 1",
        goodAfterSale: "七天无理由退换货，一年保修",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      },
      pictureDetail: [
        '../../static/image',
        '../../static/image/VineThermostat/1.png',
        '../../static/image/VineThermostat/2.png',
        '../../static/image/VineThermostat/3.png',
        '../../static/image/VineThermostat/4.png',
      ],
    },
    {
      name: '控慧智能猫眼',
      id: 'catCamera',
      //kid: 'catCamera-黑色-标准版',
      price: '829.99',
      src: '../../static/image/catCamera/Photo.png',
      imgsrc: '../../static/image/catCamera/Photo.png',
      currentPrice: '829.99',
      oldPrice: '929.99',
      thumb: [
        '../../static/image/catCamera/img1.png',
        '../../static/image/catCamera/3.png'
      ],
      sku: {
        sku_color: ['黑色'],
        sku_size: ['标准版'],
        sku_num: '122',
        sku_buy_count: '',
        sku_pic: ['../../static/image/catCamera/Photo.png']
      },
      isMark: 0,
      pictureDetail: [
        '../../static/image/catCamera/1.png',
        '../../static/image/catCamera/2.png',
        '../../static/image/catCamera/3.png',
        '../../static/image/catCamera/4.png',
        '../../static/image/catCamera/5.png',
        '../../static/image/catCamera/6.png',
      ],
      detail: {
        goodsNo: '100004948956',
        goodKind: 'QA1-1',
        goodFun: '监控、安全',
        goodExt: '充电线',
        goodsColorCover: '黑色',
        goodsUseCover: '130mm*105mm*17.5mm',
        goodsProduct: '控慧智能猫眼',
        goodpackaging: "控慧智能猫眼× 1、说明书× 1、售后服务书× 1",
        goodAfterSale: "本产品全国联保，享受三包服务，质保期为：1年质保",
        priceIntroduce: "智慧家价格：智慧家价格为商品的销售价，是您最终决定是否购买商品的依据。划线价：商品展示的划横线价格为参考价，并非原价，该价格可能是品牌专柜标价、商品吊牌价或由品牌供应商提供的正品零售价（如厂商指导价、建议零售价等）或该商品在智慧家平台上曾经展示过的销售价；由于地区、时间的差异性和市场行情波动，品牌专柜标价、商品吊牌价等可能会与您购物时展示的不一致，该价格仅供您参考。"
      }
    },
  ],
  //地址列表
  addressList: [{
      address: "北京市朝阳区112街道13号",
      address_detail: "北京市朝阳区112街道13号",
      area_code: "110105",
      city: "北京市",
      county: "朝阳区",
      id: "2",
      is_default: true,
      name: "李四",
      province: "北京市",
      tel: "1310000000",
      isBuyCard: 0, //是从购物添加地址还是在我的地址修改入口
      isToBuyOrSelect: 0 //从购物添加地址，是直接购买0还是从购物车中1 
    },
    {
      address: "广东省广州市荔湾区建设大道11号",
      address_detail: "建设大道11号",
      area_code: "440103",
      city: "广州市",
      county: "荔湾区",
      id: "3",
      name: "王五",
      province: "广东省",
      tel: "1320000000",
      isBuyCard: 0, //是从购物添加地址还是在我的地址修改入口
      isToBuyOrSelect: 0 //从购物添加地址，是直接购买0还是从购物车中1 

    }
  ],
  targetAddress: {} //要修改的地址内容的获取 
}

//修改vuex的state
const mutations = {

  addBookMark(state, data) {
    state.bookMark.push(data);
  },
  //明确关闭图文详情
  closeDetailP(state, data) {
    state.closeDetailP = data;
  },
  //提交商品详情的图文修改
  isshow_detail(state, data) {
    state.isshow_detail = data;
  },

  //提交newRouteName
  getNewRouteName(state, data) {
    state.newRouteName = data;
  },
  //提交oldRouteName
  getOldRouteName(state, data) {
    state.oldRouteName = data;
  },
  add(state, data) {
    state.selectGoods.push(data);
  },
  remove(state, data) {
    state.selectGoods.splice(data, 1);
    state.toBuy.splice(data, 1);
  },
  buy(state, data) {
    state.toBuy.push(data);
  },
  //修改立即 
  change_isRightToBuy(state) {
    if (state.isRightToBuy == false) {
      state.isRightToBuy = true;
    } else {
      state.isRightToBuy = false;
    }
  },
  //修改状态
  change_nav(state, data) {
    state.isShow_nav = data;
  },

  //修改选中的productID
  change_pro_id(state, data) {
    state.product_id = data;
  },
  //加入收藏夹
  addBook(state, data) {
    state.bookMark.push(data);
  },
  //取消收藏夹
  delBook(state, data) {
    state.bookMark.filter(item => {
      return item.id != data
    })
  },
  //删除历史搜索记录
  delHistory(state) {
    state.historySearch = [];
  },
  //搜索加入历史记录
  addHistory(state, data) {
    state.historySearch.push({
      name: data
    });
  },
  //改变收藏状态
  changeMark(state, index, data) {
    state.lists[index].isMark = data;
  },
  //赋值目标地址 
  getTargetAddress(state, data) {
    state.targetAddress = data;
  },
  //添加地址列表
  addAddressList(state, data) {
    state.addressList.push(data);
  },
  getDetailSkuList(state, data) {
    state.detailChosenList = data;
  }
}

const actions = {
  addGoods({
    commit
  }, data) {
    commit('add', data)
  },
  removeGoods({
    commit
  }, data) {
    commit('remove', data)
  },
  addToBuys({
    commit
  }, data) {
    commit('buy', data)
  },
}


//过滤数据
const getters = {
  getTarget_pro_id: (state) => (id) => {
    return state.lists.find(lists => lists.id === id)
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});


//导出store，然后在main.js中引入就是可以全局使用
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js